import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TrainingPlanService } from 'src/app/services/portfolio/training-plan.service';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { CourseUnitsService } from '../../../services/course-units.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-add-training-plan',
  templateUrl: './add-training-plan.component.html',
  styleUrls: ['./add-training-plan.component.scss']
})
export class AddTrainingPlanComponent implements OnInit {
  placeholder = "Choose a date"
  planForm: FormGroup;
  loading: boolean;
  portfolio: any;
  allSessions: any[];
  date
  selectedSessions: any[];
  titleArray: any = [];
  unitList = []
  constructor(public _trainingPlanService: TrainingPlanService,
    public _snackBar: MatSnackBar, public dialog: MatDialog, public _portfolioService: PortfolioService,
    public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public unitService: CourseUnitsService,) {
    this.createForm()
  }

  ngOnInit() {
    console.log('this.data', this.data.data)
    // this.getSessions()
    this.getAllUnits()
    if (this.data && this.data.data && this.data.data.date) {
      this.date=this.data.data.date;
      console.log('%c DATA HERE ON INIT', "color:red", this.data, this.data.data.date.toString())
      this.planForm.patchValue({
        date: this.data.data.date
      });
      this.planForm.get('date').updateValueAndValidity();
    }
    if (this.data && this.data.data && this.data.data.description) {

      this.selectedSessions = this.data.data.description.split(',')
      console.log("this.selectedSessions", this.selectedSessions)
    }
  }

  createForm() {
    this.planForm = new FormGroup({
      date: new FormControl('', Validators.required),
      title: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required)
    })
  }

  onChange(value) {
    // this.date = value;

    this.planForm.patchValue({ date: value })
    console.log("event call sucessfully", this.planForm.value)
  }


  savePlan() {
    this.loading = true
    console.log('this.planForm', this.planForm, 'data', this.data)
    let obj = {
      learnerId: this.data.data.learnerId,
      date: this.planForm.controls.date.value,
      title: this.planForm.controls.title.value,
      description: this.planForm.controls.description.value,
      jobId: this.data.data.jobId
    }
    console.log('OBJECT', obj)
    if (this.planForm.valid) {
      if (!this.data.data.isEdit) {
        console.log('IS EDIT', obj)
        this._trainingPlanService.addPlan(obj).subscribe(res => {
          console.log('res in modal', res)
          this.loading = false
          this.dialogRef.close(res)
        })
      }
      else {
        obj['eventId'] = this.data.data._id
        this._trainingPlanService.editPlan(obj).subscribe(res => {
          console.log('res in modal', res)
          this.loading = false;
          this.closoeDialog({
            action: 'edit',
            result: 'success',
            data: res
          });
          // this.dialogRef.close(res)
        })
      }
    }
    else {
      this.loading = false
      this.planForm.markAllAsTouched()
    }
  }


  compareObjects(o1: any, o2: any): boolean {
    console.log("compareObjects called", o1, o2)
    if (o1 && o2) {
      return o1.title === o2;
    }

  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  delete() {
    this.openDialog(DeleteConfirmModalComponent, 'Plan').subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._trainingPlanService.deletePlan(this.data.data._id, this.data.data.learnerId).subscribe(res => {
          console.log('DELETING LEARNER PLAN', res)
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            deleted: true
            // data: this.learnerData
          });
        }, err => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'err',
            data: err
          });
        })
      }
    })
  }

  closoeDialog(result) {
    console.log("value of close modal", result);
    this.dialogRef.close(result);
  }

  updateDesctiption(event) {
    console.log('event=====>>>>>', event)
    this.titleArray = []
    let finalList = event.value
    let array = []
    let count;
    _.forEach(finalList, track => {
      count = (_.filter(this.unitList, (o: any) => {
        if (o._id == track._id)
          array.push(o)
        // return o
      }));
    });
    console.log("total selected array", array);
    if (array && array.length) {
      _.forEach(array, (singleElement) => {
        if (singleElement && singleElement.unitNo) {
          let unit = "Unit-" + singleElement.unitNo + " " + singleElement.title
          console.log("what is unit name", unit);

          let uniqTitle = this.titleArray.includes(unit)
          // console.log("what is uniqtitle name", uniqTitle);
          if (uniqTitle == false) {
            this.titleArray.push(unit)
          }
        } else {
          let uniqTitle = this.titleArray.includes(singleElement.title)
          if (uniqTitle == false) {
            this.titleArray.push(singleElement.title)
          }
          // this.planForm.patchValue({
          //   description: singleElement.title.toString()
          // });
        }
      })
    }

    // let index = this.allSessions.find(x => x._id === event.value[0]);
    // console.log("find element detaiils", index);

    // this.planForm.patchValue({
    //   description: event.value.toString()
    // });
    // console.log("EVENT.VALUE",event.value);
  }

  closeDropDown(event) {
    console.log("event of drop down open and close", event);
    if (event == false) {
      console.log("what is final array to store in data", this.titleArray);
      this.planForm.patchValue({
        description: this.titleArray.toString()
      });
    }
  }

  getSessions() {

    console.log("in get session", this.data.data.learnerObj);

    if (this.data.data.learnerObj) {
      this._portfolioService.getSessions(this.data.data.learnerObj.job[0].course.portfolioId, this.data.data.learnerObj._id, this.data.data.jobId).subscribe(res => {
        console.log("resss", res[0]);
        this.portfolio = res[0]
        let temp = []

        this.allSessions = temp.concat(this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions))
        this.allSessions = this.allSessions.filter(session => {
          if (session.quizId.length >= 1) {
            return session;
          }
        })
        console.log("%c CONCATED ARRAY", "color:pink", this.allSessions);
        if (this.data.data._id) {
          let newArray = this.data.data.description.split(",")
          console.log("check array", newArray);


          _.forEach(newArray, (singleDescription) => {
            console.log("typeof==========", singleDescription);
            let check = singleDescription.includes('Unit')
            // console.log("if it is from track", check);
            if (check == true) {
              let unitNo = singleDescription.split(" ")
              console.log("what is unit no", unitNo);
              let singleUnit = unitNo[0].split("-")
              console.log("single unit data", singleUnit);
              let res = unitNo[1] + ' ' + unitNo[2];
              console.log("concat strinf=g", res);

              let element = this.allSessions.filter(x => Number(x.unitNo) === Number(singleUnit[1]))
              console.log("compare unit number value", element);
              let finalElement = element.find(x => x.title.toLowerCase() === res.toLowerCase())
              console.log("this is final one", finalElement);
              if (finalElement != undefined) {
                this.selectedSessions.push(finalElement._id)
              }
            } else {
              let uniq = this.allSessions.find(x => x.title.toLowerCase() === singleDescription.toLowerCase())
              // console.log("what is uniq", uniq);
              if (uniq != undefined) {
                this.selectedSessions.push(uniq._id)
              }
            }
          })
        }

        // this.allSessionsCopy = this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions)
        // this.updateData(this.allSessions)

      })
    }
  }




  getAllUnits() {
    let jobId = []
    jobId = this.data.data.learnerObj.job.filter((x) => x._id == this.data.data.jobId)
    console.log("selected job data to find", jobId);

    console.log("single job detao;s", jobId[0].course._id);

    this.unitService.getUnits(jobId[0].course._id).subscribe(res => {
      this.unitList = res;
      // this.unitsCopy = res;
      console.log("units list by course id", this.unitList)


      // if ((this.defaultUnit && this.defaultUnit == true) && (this.unitList && this.unitList.length)) {
      //   this.courseUnitId = this.unitList[0]._id
      //   this.unitId = this.unitList[0]._id
      //   this.unitNo = this.unitList[0].unitNo
      //   this.getMaterialUnitWise()
      // } else {
      //   // this.noMaterial = true
      //   this.loading = false
      // }
      // this.allUnits.emit(this.unitList)
    })
  }


}
